module.exports = __webpack_public_path__ + "img/logo.916d7bb2.png";